



























































































import {SERVER_HOST_QR} from '@/config';
import {Component, Vue, Watch} from 'vue-property-decorator';
import QrHeader from '@/components/lfs/QRLink/QrHeader.vue';
import QrStand from '@/components/lfs/QRLink/QrStand.vue';
import QrProduct from '@/components/lfs/QRLink/QrProduct.vue';
import QrBadge from '@/components/lfs/QRLink/QrBadge.vue';
import QrNone from '@/components/lfs/QRLink/QrNone.vue';
import QrTool from '@/components/lfs/QRLink/QrTool.vue';
import QrFooter from '@/components/lfs/QRLink/QrFooter.vue';
import axios from 'axios';
import QrList from '@/components/lfs/QRLink/QrList.vue';


@Component({
  name: "QrLink",
  components: {QrList, QrFooter, QrTool, QrHeader, QrStand, QrProduct, QrBadge, QrNone}
})
export default class QrLink extends Vue {


  closeList(val: any) {
    this.showlistComponent = false
    this.$router.push(val)
  }

  openList(val: string) {
    this.showlistComponent = true
    this.typeComponent = val
  }

  setLoading(val: boolean) {
    this.loading = val
  }

  @Watch('$router')
  get(NewVal: any) {
    this.showlistComponent = false
  }


  @Watch('typeComponent')
  getTypeComponent(NewVal: any) {
    if (NewVal) {
      this.itemsFromType = this.items.filter((ele: any) => {
        return ele.obj.type == NewVal
      })
    }


  }

  dialogEmailShow: boolean = false
  itemsFromType: any[] = []
  typeComponent: string | null = ''
  showlistComponent: boolean = false
  loading: boolean = false
  email: string | null = null
  items: string[] = []
  ValidEmail: boolean = false
  textValidEmail: string = ''

  @Watch('email')
  getValidEmail(NewVal: any) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (NewVal && NewVal.length > 5) {
      if (re.test(String(NewVal).toLowerCase())) {
        // this.msg['email'] = 'Please enter a valid email address';
        this.ValidEmail = true
        this.textValidEmail = ''

      } else {
        this.ValidEmail = false
        this.textValidEmail = 'Проверьте правильность email'
      }
    } else {
      this.ValidEmail = false
      this.textValidEmail = ''
    }
  }

  loadLocal(){

  }


  addItemsFromStorage(val: any) {
    this.setLoading(false)
    if (this.items.length>0) {
      if (val.obj.type === 'stand') {
        let arr = JSON.parse(JSON.stringify(this.items))
        let count =arr.filter((element: any) => {
          if (element.obj.title === val.obj.title) return element
        })
        if (count.length == 0) {
          this.items.push(val)
          localStorage.items = JSON.stringify(this.items)
        }
      }
      if (val.obj.type === 'badge') {
        {
          {
            let arr = JSON.parse(JSON.stringify(this.items))
            let count = arr.filter((element: any) => {
              if (element.path === val.path && element.obj.type === val.obj.type) return element
            }).length
            if (count == 0) {
              this.items.push(val)
              localStorage.items = JSON.stringify(this.items)
            }
          }
        }
      }
      if (val.obj.type === 'product') {
        {
          let arr = JSON.parse(JSON.stringify(this.items))
          let count = arr.filter((element: any) => {
            if (element.path === val.path && element.obj.type === val.obj.type) return element
          }).length
          if (count == 0) {
            this.items.push(val)
            localStorage.items = JSON.stringify(this.items)
          }
        }
      }
    } else {
      this.items.push(val)
      localStorage.items = JSON.stringify(this.items)
    }
  }


  showError() {
    this.isComponent = 'QrNone'
    this.loading = false
  }

  created() {
    this.showlistComponent = false
    if (localStorage.getItem('email')) {
      this.email = localStorage.getItem('email')
    }
    if (localStorage.items) {
      this.items = JSON.parse(localStorage.items)
    }
    this.getComponent()
  }

  isComponent: string = 'QrNone'
  show: string | null = this.$route.params.show
  stand: string | null = this.$route.params.stand
  product: string | null = this.$route.params.product
  badge: string | null = this.$route.params.badge
  params: string | null = null
  loadingFromServer: boolean = false
  showAlert: boolean = false
  classAlert: string = 'QRmessage--green'
  textAlert: string = 'Письмо отправлено'


  get CountBadges() {
    return this.items.filter((element: any) => {
      if (element.path.indexOf('/b/') != -1) {
        return element
      }
    }).length
  }

  get CountProducts() {
    return this.items.filter((element: any) => {
      if (element.path.indexOf('/p/') != -1) {
        return element
      }
    }).length
  }

  get CountStands() {
    let count = 0;
    this.items.filter((element: any) => {
      if (element.path.indexOf('/s/') != -1) {
        count += element.obj.company.length
      }
    })
    return count
  }

  getComponent() {
    if (!this.show) this.isComponent = 'QrNone'

    if (this.stand) {
      this.params = this.stand
      this.isComponent = 'QrStand'
    }
    if (this.product) {
      this.params = this.product
      this.isComponent = 'QrProduct'
    }
    if (this.badge) {
      this.params = this.badge
      this.isComponent = 'QrBadge'
    }


  }

  localStorageEmail() {
    if (localStorage.email) {
      this.email = localStorage.email
    } else {
      this.email = ''
    }
  }

  async clickBtnSendMail() {
    this.dialogEmailShow = true
    this.localStorageEmail()
  }

  async sendMailToServer() {
    localStorage.email = this.email
    let sendArr = this.items.map((ele: any) => {
      return ele.path
    })
    if (localStorage.email) {
      this.email = localStorage.email
    } else {
      this.email = ''
    }
    const params = {
      email: this.email,
      links: sendArr

    }
    this.dialogEmailShow = false
    try {
      const {data} = await axios.post(SERVER_HOST_QR + 'collected-data-from-links/upload', params)
      if (data.uploaded) {
        this.trueSend()
      } else {
        this.errorSend()
      }

    } catch (e) {
      this.errorSend()
    }
  }

  trueSend() {
    this.classAlert = 'QRmessage--green'
    this.textAlert = 'Письмо отправлено'
    this.showAlert = true
    setTimeout(() => {
      this.showAlert = false
    }, 5000)
  }

  errorSend() {
    this.classAlert = 'QRmessage--red'
    this.textAlert = 'Письмо не отправлено'
    this.showAlert = true
    setTimeout(() => {
      this.classAlert = 'QRmessage--green'
      this.textAlert = 'Письмо отправлено'
      this.showAlert = false
    }, 5000)
  }

  clickBtnSendMailClose() {
    this.dialogEmailShow = false
    this.localStorageEmail()
  }

}
